import React, { useContext } from 'react'
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import verticaldots from '../../../Assets/Images/vertical-dots.svg';
import viewicon from '../../../Assets/Images/wideView.svg'
import { common } from '@mui/material/colors';
import { InsightsContext } from '../../../Context/InsightsContext';

const COLORS = ['#ACC549', '#66D7DE', '#6A9DFF', '#836FFB', '#BA59E7', '#DB4CB2', '#F77DAA', '#EA7369', '#F48956', '#CCCCCC']
const COLORSIN = ['#ACC54980', '#66D7DE80', '#6A9DFF80', '#836FFB80', '#BA59E780', '#DB4CB280', '#F77DAA80', '#EA736980', '#F4895680', '#CCCCCC80']

export default function Passions({ setTableViewOpen }) {
    const { top10Skills, top10SkillGroups, top5Causes, top5CauseGroups, top5Populations, top5PopulationGroups, top5Communities } = useContext(InsightsContext);

    const skillGroups = top10SkillGroups.map(sg => ({ name: sg.skill_group, value: sg.totalcount }));
    const topSkills = top10Skills.map(sk => ({ name: sk.skill, value: sk.count }));
    const skills = [];
    top10SkillGroups.forEach((sg, i) => skills.push(...(Object.keys(sg.skills).map(sk => ({ name: sk, value: sg.skills[sk], index: i })))));

    const causeGroups = top5CauseGroups.map(cg => ({ name: cg.cause_group, value: cg.totalcount }));
    const topCauses = top5Causes.map(cs => ({ name: cs.cause, value: cs.count }));
    const causes = [];
    top5CauseGroups.forEach((cg, i) => causes.push(...(Object.keys(cg.causes).map(cs => ({ name: cs, value: cg.causes[cs], index: i })))));

    const populationGroups = top5PopulationGroups.map(pg => ({ name: pg.population_group, value: pg.totalcount }));
    const topPopulations = top5Populations.map(pl => ({ name: pl.population, value: pl.count }));
    const populations = [];
    top5PopulationGroups.forEach((pg, i) => populations.push(...(Object.keys(pg.populations).map(pl => ({ name: pl, value: pg.populations[pl], index: i })))));

    const communities = top5Communities.map(cm => ({ name: cm.community, value: cm.count }))

    const getLegendIndex = (name, arr) => {
        return arr.find(x => x.name === name)?.index;
    }

    const renderGroupLegend = (data) => {
        return (
            <ul>
                {data.map((entry, index) => (
                    <li key={`item-${index}`}>
                        <div>
                            <span style={{ backgroundColor: COLORS[index % COLORS.length] }} className="legend-color-box" />
                            {entry.name}
                        </div>
                        {entry.value}
                    </li>
                ))}
            </ul>
        )
    };
    const renderLegend = (data, array) => (
        <ul>
            {data.map((entry, index) => (
                <li key={`item-${index}`}>
                    <div>
                        <span style={{ backgroundColor: COLORS[getLegendIndex(entry.name, array) % COLORS.length] }} className="legend-color-box" />
                        {entry.name}
                    </div>
                    {entry.value}
                </li>
            ))}
        </ul>
    );
    return (
        <div className="passion">
            <div className="section1">
                <div className="heading">
                    <h3>Skills</h3>
                    <div className='icons'>
                        <img src={viewicon} alt="view" onClick={() => setTableViewOpen(true)} />
                        <img src={verticaldots} alt="option" />
                    </div>
                </div>
                <div className="chart-container">
                    <PieChart width={380} height={380} >
                        <Pie
                            data={skills}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={160}
                            innerRadius={100}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {skills.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[entry.index % COLORSIN.length]} />
                            ))}
                        </Pie>
                        <Pie
                            data={skillGroups}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            outerRadius={100}
                            innerRadius={40}
                            fill="#82ca9d"
                            dataKey="value"
                        >
                            {skillGroups.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORSIN[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                    <div className="legend">
                        <div className='list'>
                            <p>Top Skill Groups</p>
                            {renderGroupLegend(skillGroups)}
                        </div>
                        <div className='list'>
                            <p>Top Individual Skills</p>
                            {renderLegend(topSkills, skills)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="section2">
                <div className="card">
                    <div className="heading">
                        <h3>Causes</h3>
                        <div className='icons'>
                            <img src={viewicon} alt="view" onClick={() => setTableViewOpen(true)} />
                            <img src={verticaldots} alt="option" />
                        </div>
                    </div>
                    <div className="chart-container">
                        <PieChart width={380} height={380} >
                            <Pie
                                data={causes}
                                cx={200}
                                cy={200}
                                labelLine={false}
                                outerRadius={160}
                                innerRadius={100}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {causes.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[entry.index % COLORSIN.length]} />
                                ))}
                            </Pie>
                            <Pie
                                data={causeGroups}
                                cx={200}
                                cy={200}
                                labelLine={false}
                                outerRadius={100}
                                innerRadius={40}
                                fill="#82ca9d"
                                dataKey="value"
                            >
                                {causeGroups.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORSIN[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                        <div className="legend">
                            <div className='list'>
                                <p>Top 5 Causes</p>
                                {renderLegend(topCauses, causes)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="heading">
                        <h3>Populations</h3>
                        <div className='icons'>
                            <img src={viewicon} alt="view" onClick={() => setTableViewOpen(true)} />
                            <img src={verticaldots} alt="option" />
                        </div>
                    </div>
                    <div className="chart-container">
                        <PieChart width={380} height={380} >
                            <Pie
                                data={populations}
                                cx={200}
                                cy={200}
                                labelLine={false}
                                outerRadius={160}
                                innerRadius={100}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {populations.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[entry.index % COLORSIN.length]} />
                                ))}
                            </Pie>
                            <Pie
                                data={populationGroups}
                                cx={200}
                                cy={200}
                                labelLine={false}
                                outerRadius={100}
                                innerRadius={40}
                                fill="#82ca9d"
                                dataKey="value"
                            >
                                {populationGroups.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORSIN[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                        <div className="legend">
                            <div className='list'>
                                <p>Top 5 Populations</p>
                                {renderLegend(topPopulations, populations)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="heading">
                        <h3>Communities</h3>
                        <div className='icons'>
                            <img src={viewicon} alt="view" onClick={() => setTableViewOpen(true)} />
                            <img src={verticaldots} alt="option" />
                        </div>
                    </div>
                    <div className="chart-container">
                    <PieChart width={380} height={380} >
                            <Pie
                                data={communities}
                                cx={200}
                                cy={200}
                                labelLine={false}
                                outerRadius={160}
                                innerRadius={100}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {communities.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                        <div className="legend">
                            <div className='list'>
                                <p>Top 5 Communities</p>
                                {renderGroupLegend(communities)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
